import { IAttribute } from '@gn-audio/core/api/product-catalogue/models/attribute';
import { Component, Input, SimpleChanges } from 'angular-ts-decorators';
import { IProductComparisonAttributeSet } from '../models/product-comparison-attribute-set';

import template from './product-comparison-section.component.html';

@Component({
  selector: 'productComparisonSection',
  template,
})
export class ProductComparisonSectionComponent {
  @Input() public readonly attributeSet?: IProductComparisonAttributeSet;
  @Input() public readonly productAttributes?: IAttribute[];
  public visibilityValues: boolean[] = [];
  public isVisible = true;
  public isCollapsed = false;

  public ngOnChanges(changes: SimpleChanges<ProductComparisonSectionComponent>) {
    if (changes.productAttributes) {
      this.visibilityValues = [];
    }
  }

  public onVisibilityChange(isVisible: boolean) {
    this.visibilityValues.push(isVisible);
    this.isVisible = (this.visibilityValues.some((x: boolean) => x));
  }

  public toggle() {
    this.isCollapsed = !this.isCollapsed;
  }
}
